"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyHelpButtonPopup = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var DocumentListModal_1 = require("../../widgets/annual/motor/DocumentListModal");
var AnnualHomeDocumentListModal_1 = require("../../widgets/annual/home/AnnualHomeDocumentListModal");
var StickyHelpButtonPopup = exports.StickyHelpButtonPopup = /** @class */ (function (_super) {
    __extends(StickyHelpButtonPopup, _super);
    function StickyHelpButtonPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showPopup: false,
            documentPathToSizeMaps: [],
            allProducts: [],
            faqUrl: "https://www.allianz.co.uk/insurance/car-insurance/your-account-faqs.html"
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    StickyHelpButtonPopup.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe(function (policies) {
            var _a, _b, _c, _d;
            _this.setState({
                policies: policies
            });
            if (policies && policies.length > 0) {
                _this.customerPortalService.getProfile().subscribe(function (party) {
                    _this.setState({ party: party });
                });
                if ((_b = (_a = policies[0].interaction) === null || _a === void 0 ? void 0 : _a.factors) === null || _b === void 0 ? void 0 : _b.originalQuoteDate) {
                    var originalQuoteDateRaw = (_d = (_c = policies[0].interaction.renewalDetails) === null || _c === void 0 ? void 0 : _c.periodStartDate) !== null && _d !== void 0 ? _d : policies[0].startDate;
                    _this.originalLatestQuoteDate = moment.utc(originalQuoteDateRaw, moment.ISO_8601);
                }
                var allProducts_1 = [];
                policies.forEach(function (policy) {
                    if (policy.products && policy.products.length > 0) {
                        allProducts_1.push(policy.products[0]);
                    }
                });
                _this.setState({ allProducts: allProducts_1 });
                var url = window.location.href.replace(/\/$/, '');
                var policyNumber_1 = url.substring(url.lastIndexOf('/') + 1);
                var policy = policies.find(function (policy) { return policy.policyNumber == policyNumber_1; });
                if (policy) {
                    _this.setState({
                        policy: policy
                    });
                    var isHomeInteraction = services_1.productHelper.isHome(policy.interaction);
                    _this.setState({
                        isHomeInteraction: isHomeInteraction
                    });
                    var faqUrl = isHomeInteraction
                        ? "https://www.allianz.co.uk/insurance/home-insurance/faqs.html"
                        : "https://www.allianz.co.uk/insurance/car-insurance/faqs.html";
                    _this.setState({
                        faqUrl: faqUrl
                    });
                }
            }
        });
        this.customerPortalService.getUserById().subscribe(function (user) {
            _this.setState({
                user: user
            });
        });
    };
    StickyHelpButtonPopup.prototype.render = function () {
        var _a;
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        var user = (_a = this.state, _a.user), party = _a.party;
        var coverTier = this.state.policies && this.state.policies.length > 0 ? this.state.policies[0].interaction.coverTier : "ALLIANZ";
        if ((party || user) && this.originalLatestQuoteDate != undefined) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { onClick: this.toggle }, this.props.children),
                React.createElement(reactstrap_1.Modal, { className: "falcon-modal", isOpen: this.state.showPopup, toggle: this.toggle },
                    React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn }),
                    React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                        React.createElement("div", { className: "sticky-help-popup-help-header" },
                            React.createElement("img", { className: "sticky-help-popup-help-icon", src: "/img/sticky_help_button_text.png" })),
                        React.createElement("p", { className: "mt-4 mb-0 ml-3 mr-3 font-weight-semi-bold" },
                            " Hi ",
                            party ? party.firstName + "," : ""),
                        React.createElement("p", { className: "mt-2 mb-0 ml-3 mr-3" },
                            "We like to make things easy and save everyone time, so we",
                            ' ',
                            React.createElement("span", { className: "font-weight-semi-bold" }, "only use the phones when you need to make claim."),
                            ' ',
                            "Our online team are here for you if you have a question or need some help."),
                        React.createElement("p", null,
                            "To use our live chat ",
                            React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/chat.svg"), alt: "Chat" }),
                            " please visit our ",
                            React.createElement("a", { className: "help-popup-hyperlink-style", href: "https://www.allianz.co.uk/insurance/car-insurance/contact-us.html", target: "_blank" }, "contact page"),
                            "."),
                        React.createElement("div", { id: "contact-options" },
                            React.createElement("div", { className: "container" },
                                React.createElement("div", { className: "item" },
                                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/phone-crossed.svg"), alt: "Manage your policy yourself online" }),
                                    React.createElement("p", null,
                                        "Manage your policy ",
                                        React.createElement("strong", null, "YOURSELF"),
                                        " online")),
                                React.createElement("div", { className: "item" },
                                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/headset.svg"), alt: "Only call us to claim" }),
                                    React.createElement("p", null, "Only call us to claim")),
                                React.createElement("div", { className: "item" },
                                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/piggy-bank.svg"), alt: "No admin fees" }),
                                    React.createElement("p", null, "No admin fees")))),
                        React.createElement("p", { className: "mt-2 mb-0 ml-3 mr-3" },
                            "We\u2019ve answered your questions before you even thought of them! Head to our",
                            ' ',
                            React.createElement("a", { className: "help-popup-hyperlink-style", href: this.state.faqUrl, target: "_blank" }, "FAQs"),
                            " section to save yourself time"),
                        React.createElement("p", { className: "mt-4 mb-0 ml-3 mr-3 font-weight-semi-bold" }, "Most common questions"),
                        React.createElement("div", { className: "mr-3 ml-3" },
                            React.createElement("details", null,
                                React.createElement("summary", null, "How do I manage my policy?"),
                                React.createElement("div", null,
                                    React.createElement("p", { className: "mb-0" }, "Simply sign into your account to manage your policy. Here's what you can do in your online account..."),
                                    React.createElement("ul", null,
                                        React.createElement("li", null, "add a new driver to your cover"),
                                        React.createElement("li", null, "change your car"),
                                        React.createElement("li", null, "add optional extras (e.g Breakdown cover)"),
                                        React.createElement("li", null, "cancel or renew your cover"),
                                        React.createElement("li", null, "manage your payments"),
                                        React.createElement("li", null, "see your policy documents")))),
                            this.state.policies && (this.hasProduct(services_1.PRODUCT_MOTOR) || (this.hasProduct(services_1.PRODUCT_WOLF_MOTOR))) &&
                                React.createElement("details", null,
                                    React.createElement("summary", null, "Optional extras"),
                                    this.state.policies && this.hasProduct(services_1.PRODUCT_MOTOR) && this.getSubscriptionProductOptionalExtrasText(),
                                    this.state.policies && this.hasProduct(services_1.PRODUCT_WOLF_MOTOR) && this.getAnnualProductOptionalExtrasText(),
                                    this.state.policies && this.hasProduct(services_1.PRODUCT_RENTERS) && this.getRentersProductOptionalExtrasText()),
                            React.createElement("details", { className: "mb-3" },
                                React.createElement("summary", null, "Where can I find my policy documents?"),
                                React.createElement("div", null,
                                    React.createElement("p", null, "You can access your policy documents in your online account 24/7."),
                                    this.state.policy && this.state.isHomeInteraction &&
                                        React.createElement(AnnualHomeDocumentListModal_1.AnnualHomeDocumentListModal, { policyDate: new Date(this.state.policy.startDate), coverTier: coverTier, withTitle: false, annualHomeFixedAddons: this.state.policy.interaction.annualHomeFixedAddons }),
                                    this.state.allProducts && this.state.allProducts.length > 0 && !this.state.isHomeInteraction &&
                                        React.createElement(DocumentListModal_1.DocumentListModal, { productName: services_1.productHelper.parseProductName(this.state.allProducts[0].toString()), policyDate: this.originalLatestQuoteDate.toDate(), isBDIVisible: false, isMLEVisible: false, isAccordion: false, coverTier: coverTier }))))))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    StickyHelpButtonPopup.prototype.toggle = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    StickyHelpButtonPopup.prototype.hasProduct = function (filterProduct) {
        return this.state.allProducts.filter(function (value) { return value == filterProduct; }).length > 0;
    };
    StickyHelpButtonPopup.prototype.getAnnualProductOptionalExtrasText = function () {
        return (React.createElement("div", null,
            React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "Protected no claim discount (NCD)"),
            React.createElement("p", { className: "pt-0 mb-0" }, "No matter how many claims you make you won't lose your NCD"),
            React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "Breakdown cover"),
            React.createElement("p", { className: "pt-0 mb-0" }, "Choose between 3 levels of cover: Local, National and European."),
            React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "Family package"),
            React.createElement("p", { className: "pt-0" }, "Offer cover for:"),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("span", { className: "mb-0 font-weight-semi-bold" }, "Child car seats"),
                    " - We\u2019ll replace any child seat with a new one of the same quality, even if it looks un-damaged after a theft, accident or fire."),
                React.createElement("li", null,
                    React.createElement("span", { className: "mb-0 font-weight-semi-bold" }, "Continuing your journey"),
                    " - If your car can\u2019t be driven after a claim and you\u2019re more than 25 miles from where you started, we\u2019ll repay you up to \u00A3500 for any accommodation or alternative transport costs you\u2019ve arranged to carry on your journey. Please keep your receipts as we\u2019ll need to see these"),
                React.createElement("li", null,
                    React.createElement("span", { className: "mb-0 font-weight-semi-bold" }, "In-car equipment"),
                    " - Any non standard equipment fitted after the car\u2019s manufacture then we\u2019ll pay for permanently fitted or portable equipment up to \u00A31000. Portable equipment must have been kept out of sight in the glove box or locked boot at the time of a theft claim."))));
    };
    StickyHelpButtonPopup.prototype.getSubscriptionProductOptionalExtrasText = function () {
        return (React.createElement("div", null,
            React.createElement("p", { className: "mb-0" },
                React.createElement("strong", null, "Guaranteed hire car")),
            React.createElement("p", { className: "pt-0 mb-0" }, "You'll get a hire car if your car is stolen or off the road following an accident"),
            React.createElement("p", { className: "mb-0" },
                React.createElement("strong", null, "Motor legal expenses")),
            React.createElement("p", { className: "pt-0 mb-0" },
                "You're covered ",
                React.createElement("strong", null, "up to \u00A3100,000"),
                " for legal expenses if you need help to cover the costs of legal action if you had an accident.")));
    };
    StickyHelpButtonPopup.prototype.getRentersProductOptionalExtrasText = function () {
        // Currently not needed
        return React.createElement(React.Fragment, null);
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], StickyHelpButtonPopup.prototype, "customerPortalService", void 0);
    return StickyHelpButtonPopup;
}(React.Component));
//# sourceMappingURL=StickyHelpButtonPopup.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/modals/StickyHelpButtonPopup.js
// module id = 1335
// module chunks = 0